import linesImage from '@assets/images/lines_1.png';
import { Image, XStack, YStack } from 'tamagui';

interface LoginDecorativeBackgroundProps {
  isSmallScreen: boolean;
  children: React.ReactNode;
}

const decorativeImageWidth = 445;
const decorativeImageHeight = 350;

export function LoginDecorativeBackground({
  isSmallScreen = true,
  children,
}: LoginDecorativeBackgroundProps): React.ReactNode {
  const topOffset = isSmallScreen ? 140 : 80;
  const rightOffset = isSmallScreen ? 120 : 0;
  const bottomOffset = isSmallScreen ? 40 : 70;
  const leftOffset = isSmallScreen ? 170 : 70;

  return (
    <YStack flex={1}>
      <XStack
        justifyContent="flex-end"
        alignItems="flex-start"
        pointerEvents="none"
        maxHeight={decorativeImageHeight - topOffset}
      >
        <Image
          source={linesImage}
          style={{
            transform: [{ scaleX: -1 }, { scaleY: -1 }],
            maxHeight: decorativeImageHeight,
            maxWidth: decorativeImageWidth,
            top: -topOffset,
            right: -rightOffset,
          }}
        />
      </XStack>
      <YStack gap="$true" flex={1} justifyContent="center" alignItems="center">
        {children}
      </YStack>
      <XStack
        justifyContent="flex-start"
        alignItems="flex-end"
        pointerEvents="none"
        maxHeight={decorativeImageHeight - bottomOffset}
      >
        <Image
          source={linesImage}
          style={{
            maxHeight: decorativeImageHeight,
            maxWidth: decorativeImageWidth,
            left: -leftOffset,
            bottom: -bottomOffset,
          }}
        />
      </XStack>
    </YStack>
  );
}
